export default {
    //@ts-ignore
    install(Vue, options) {
        Vue.mixin({
            methods: {
                //@ts-ignore
                async RefreshUserToken() {
                    try {
                        //@ts-ignore
                        var response = await this.$http.post("api/authentication/refresh", { token: localStorage.getItem("CTC_REFRESH_TOKEN") });
                        //@ts-ignore
                        this.$store.dispatch("refresh", response.data);
                        return response;
                    }
                    catch (err) {
                        console.error(err);
                        return Promise.reject(err);
                    }
                }
            },
            mounted() {
                Vue.prototype.$refreshToken = this.RefreshUserToken;
            }
        });
    }
}